import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { company, navLinks } from "@/mocks/home";

const legalLinks = [
  { label: "Política de Privacidade", to: "/politica-de-privacidade" },
  { label: "Termos e Condições", to: "/termos-e-condicoes" },
  { label: "Política de Cookies", to: "/politica-de-cookies" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-950">
      <div className="mx-auto w-full max-w-container px-4 py-14 md:px-6 lg:px-10">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <img
                src={company.logo}
                alt="Logótipo da Porta31 Condomínios"
                title="Porta31 Condomínios"
                className="h-16 w-auto object-contain md:h-18"
              />
              <span className="font-heading text-lg font-bold leading-tight tracking-tight text-background-50 md:text-xl">
                {company.name}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              {company.slogan} Gestão de condomínios com transparência, rigor e proximidade em Vila Nova de Famalicão.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={company.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram da Porta31 Condomínios"
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-50/15 text-background-100 transition-colors duration-300 hover:border-primary-400 hover:text-primary-300"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={company.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook da Porta31 Condomínios"
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-50/15 text-background-100 transition-colors duration-300 hover:border-primary-400 hover:text-primary-300"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wide text-background-50">Navegação</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="cursor-pointer text-sm text-background-300 transition-colors duration-300 hover:text-primary-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-wide text-background-50">Contactos</h3>
            <ul className="mt-4 space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 flex-none text-primary-300" />
                <span className="text-sm text-background-300">{company.location}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="mt-0.5 h-4 w-4 flex-none text-primary-300" />
                <a
                  href={company.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Contactar a Porta31 por WhatsApp"
                  className="cursor-pointer text-sm text-background-300 transition-colors duration-300 hover:text-primary-300"
                >
                  {company.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 flex-none text-primary-300" />
                <a
                  href={`mailto:${company.email}`}
                  aria-label="Enviar email para a Porta31 Condomínios"
                  className="cursor-pointer break-all text-sm text-background-300 transition-colors duration-300 hover:text-primary-300"
                >
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-50/10 pt-6 lg:flex-row">
          <p className="text-xs text-background-400">
            © {year} {company.name}. Todos os direitos reservados.
          </p>
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {legalLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="cursor-pointer whitespace-nowrap text-xs text-background-300 transition-colors duration-300 hover:text-primary-300"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="text-xs text-background-400">
            Website desenvolvido por{" "}
            <a
              href="https://ponto-zero.pages.dev/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Ponto Zero Apps"
              className="cursor-pointer font-medium text-background-200 transition-colors duration-300 hover:text-primary-300"
            >
              Ponto Zero Apps
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}